/**
 * ARTWORK CONFIGURATION
 *
 * Source of truth: /public/IMAGE/arts/artworks.json
 * DO NOT hardcode artwork data here - fetch from artworks.json instead
 * See: Arts.js line 22 for example
 */

/**
 * CATEGORIES
 */
export const CATEGORIES = [
  { id: "all", label: "All" },
  { id: "landscape", label: "Landscape" },
  { id: "street", label: "Street" },
  { id: "nature", label: "Nature" },
  { id: "abstract", label: "Abstract" },
  { id: "models", label: "Models" },
];

/**
 * PRICE TIERS
 * Customize your pricing structure
 */
export const PRICE_TIERS = {
  digital: { label: "Digital Download", defaultPrice: 29 },
  small: { label: "Small Print (12×18)", defaultPrice: 149 },
  large: { label: "Large Print (24×36)", defaultPrice: 349 },
};

/**
 * SIZE LABELS (for display)
 */
export const SIZE_LABELS = {
  digital: "Digital Download",
  small: "Small Print (12×18)",
  large: "Large Print (24×36)",
  donate: "Donation",
};
